import useConfigStore from '@/stores/site/config';

export default [
	{
		path: '',
		redirect: 'dashboard/',
		meta: { showInNav: false },
	},
	{
		path: 'dashboard/',
		name: 'dashboard',
		component: () => import('@/views/Agents/AgentDashboard'),
		meta: {
			exact: false,
			icon: 'gauge-high',
			label: 'Dashboard',
			showInNav: true,
			title: 'MySFDomain - Agent Dashboard',
		},
	},
	{
		path: 'domains/',
		component: () => import('@/components/common/EmptyRouterView'),
		children: [
			{
				path: '',
				name: 'domains',
				component: () => import('@/views/Agents/Domains/DomainList'),
				meta: {
					title: 'Domains',
				},
			},
			{
				path: 'purchase/',
				name: 'purchase',
				component: () => import('@/views/Agents/Domains/DomainPurchase'),
				beforeEnter: checkForDisabledDomains,
				meta: {
					title: 'Purchase Domain',
				},
			},

			{
				path: 'transfer/',
				name: 'transfer domain',
				component: () => import('@/views/Agents/Domains/DomainTransfer'),
				beforeEnter: checkForDisabledDomains,
				meta: {
					title: 'Transfer Domain',
				},
			},
		],
		meta: {
			exact: false,
			title: 'Domains',
			icon: 'earth',
			showInNav: true,
		},
	},
	{
		path: 'emails/',
		name: 'emails',
		component: () => import('@/views/Agents/EmailRedirects'),
		meta: {
			title: 'Emails',
			showInNav: true,
			icon: 'envelope',
		},
	},
	{
		path: 'adwords/',
		name: 'adwords',
		component: () => import('@/views/Agents/AdwordsAccount'),
		meta: {
			title: 'Adwords',
			icon: 'chart-line',
		},
	},
	{
		path: 'campaigns/',
		name: 'campaigns',
		component: () => import('@/views/Agents/CampaignStats'),
		meta: {
			title: 'Campaigns',
			label: 'Campaigns',
			showInNav: true,
			icon: 'file',
		},
	},
	{
		path: 'calltracking/',
		name: 'calltracking',
		components: {
			default: () => import('@/views/Agents/CallTracking'),
			toolbar: () => import('@/components/toolbars/CalltrackingToolbar'),
		},
		meta: {
			title: 'Call Tracking',
			showInNav: true,
			icon: 'phone',
		},
	},
	{
		path: 'pricing/',
		name: 'pricing',
		component: () => import('@/views/Agents/Domains/DomainPricing'),
		meta: {
			title: 'Pricing',
			showInNav: true,
			icon: 'dollar-sign',
		},
	},
	{
		path: 'payment/',
		name: 'payment',
		component: () => import('@/views/Agents/PaymentSettings'),
		meta: {
			title: 'Payment Info',
			showInNav: true,
			icon: 'credit-card',
		},
	},
	{
		path: 'billing/',
		component: () => import('@/components/common/EmptyRouterView'),
		meta: {
			title: 'Billing History',
			showInNav: true,
			icon: 'money-bill',
		},
		children: [
			{
				path: '',
				name: 'billing',
				component: () => import('@/views/Agents/BillingHistory'),
				meta: {
					title: 'Billing History',
				},
			},
			{
				path: ':receipt/',
				name: 'Receipt',
				component: () => import('@/views/Agents/BillingSummary'),
			},
		],
	},
	{
		path: 'team/',
		name: 'team',
		component: () => import('@/views/Agents/TeamSettings'),
		meta: {
			label: 'Team Settings',
			title: 'Manage Team Permissions',
			showInNav: true,
			icon: 'people-group',
		},
	},
	{
		path: 'welcome/',
		name: 'welcome',
		component: () => import('@/views/Agents/NewAgent'),
		meta: {
			showInNav: false,
		},
	},
];
function checkForDisabledDomains(to, from, next) {
	const configStore = useConfigStore();
	const enabled = configStore.domainTransactionsEnabled;
	if (enabled) {
		next();
	} else {
		next({ name: 'domains', params: { ...to.params } });
	}
}
